import productViewHtml from './productview.component.html';
class ProductViewController {
    constructor($scope, $location, $window, $http, $filter, $q, $httpParamSerializer, SnackbarService, CartService, ModalService, ProductViewService, $rootScope, CropService) {
        'ngInject';

        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$window = $window;
        this.$location = $location;
        this.$http = $http;
        this.$filter = $filter;
        this.$q = $q;
        this.$httpParamSerializer = $httpParamSerializer;
        this.SnackbarService = SnackbarService;
        this.ModalService = ModalService;
        this.CartService = CartService;
        this.ProductViewService = ProductViewService;
        this.CropService = CropService;
        this.loading = false;

        this.imagesUrls = [];
        this.currentImage = null;
        this.attributes = new Map();
        this.colors = new Map();
        this.price = {
            from: false,
            catalog_price: 0,
            price_old_gros: 0,
            price_gros: 0,
            price_net: 0,
            omnibus_lowest_price: 0
        };
        this.availability = {
            min: false,
            name: "",
            quantity: ""
        };
        this.productCode = null;
        this.eanCode = null;
        this.selectedColorId = null;
        this.selectedAttributes = {};
        this.selectedAttributesSimulation = {};
        this.selectedComplementaryProduct = null;
        this.matchingVariantsForAttributeValue = {};
        this.quantity = 1;
        this.filtersOrder = [
            {type: 'attribute', id: 16}, // Rodzaj ramy
            {type: 'color', id: 0}, // Kolor
            {type: 'attribute', id: 1}, // Biegi
            {type: 'attribute', id: 123}, // Bagażnik
            {type: 'attribute', id: 14}, // Rozmiar ramy
            {type: 'attribute', id: 141} // Silnik
        ];
        this.filtersOmitAvailability = [141];
        this.filtersOmitDescription = [141];
        this.filters = [];
        this.frameAttributeId = 16;
        this.inputSelectAttributes = [];
        this.ratingStars = [];
        this.voucher = {
            price: 200,
            name: '',
            email: '',
            sent_at: new Date().toJSON().slice(0, 10),
            message: '',
            custom_image: null,
            file_id: null,
            file_url: null
        };
        this.voucherForm1 = null;
        this.voucherForm2 = null;

        const today = new Date();
        this.voucherSentAtDateOptions = {
            minDate: new Date(),
            maxDate: new Date(today.setMonth(today.getMonth() + 3)),
            disableMobile: true,
            onClose: (selectedDates, dateStr, instance) => {
                if (!this.voucher.sent_at) {
                    this.voucher.sent_at = dateStr;
                    this.$scope.$apply();
                }
            }
        }
        this.$scope.excludeEmojisRegExp = "[a-zA-ZÀ-ž\\s0-9\\\"+\\-!@#$%^&*()\\[\\]={};:'<>,.\/|\\\\_?]+";
    }

    get canBuy() {
        if (this.product.type != 2) {
            if (this.variants && this.variants.length > 0) {
                if (!this.selectedVariant) return false;

                const matches = this.variants.filter(variant => variant.id == this.selectedVariant);

                if (matches.length < 1) return false;

                if (matches[0].can_buy == '0') return false;
            } else {
                if (this.product.can_buy == '0') return false;
            }

            return true;
        } else {
            return this.voucherForm1 && this.voucherForm1.$valid && this.voucherForm2 && this.voucherForm2.$valid
                && (this.voucher.custom_image || this.voucher.file_id);
        }
    }

    get name() {
        if (this.selectedVariant) {
            const matches = this.variants.filter(variant => variant.id == this.selectedVariant);

            return `${this.product.name} - ${matches[0].name}`;
        } else {
            return this.product.name;
        }
    }

    get variantName() {
        if (this.selectedVariant) {
            const matches = this.variants.filter(variant => variant.id == this.selectedVariant);

            return ` ${matches[0].name}`;
        } else {
            return '';
        }
    }

    get defaultPhoto() {
        return this.chooseDefaultImage();
    }

    get discount() {
        if (!this.price.price_old_gros || this.price.price_old_gros === 0 || this.price.price_old_gros === this.price.price_gros) {
            return 0;
        }

        return -Math.round(((this.price.price_old_gros - this.price.price_gros) / this.price.price_old_gros) * 100) + '%';
    }

    $onInit() {
        this.$scope.$on("$locationChangeSuccess", (event, newUrl, oldUrl) => {
            if (newUrl == oldUrl) return;
            if (!this.variants || this.variants.length < 1) return;

            let segments = newUrl.split('/');
            let segmentsOld = oldUrl.split('/');

            // No selected variant
            if (segmentsOld.length > segments.length) {
                this.selectVariant(null);
                return;
            }

            const slug = segments[segments.length - 1];
            let matches = this.variants.filter(variant => variant.slug == slug);

            if (this.selectedColorId && matches.length > 1) {
                matches = matches.filter(variant => parseInt(variant.color_id) == this.selectedColorId);
            }

            if (matches.length < 1) {
                return;
            }

            // Sprawdzamy czy wybrany wariant pasuje do wyników (matches) pasujących do aktualnego URLa
            if (matches.find(match => parseInt(match.id) === parseInt(this.selectedVariant))) {
                return;
            }

            this.selectVariant(matches[0]);
        });

        this.ratingValue = parseFloat(this.ratingValue);

        for (let i = 1; i <= 5; i++) {
            this.ratingValue >= i - .1 ? this.ratingStars.push('star-full') : this.ratingStars.push('star-empty');
        }

        this.imagesUrls = this.images.map(image => image.url);

        this.price = {
            from: false,
            catalog_price: this.product.catalog_price,
            price_old_gros: this.product.old_price,
            price_gros: this.product.price_gros,
            price_net: this.product.price_net,
            omnibus_lowest_price: this.product.omnibus_lowest_price
        };

        this.availability = {
            id: this.product.avail_id,
            name: this.product.displayed_availability,
            quantity: this.product.quantity
        };

        if (this.product.product_code && this.product.product_code != '') {
            this.productCode = this.product.product_code;
        }

        if (this.product.barcode && this.product.barcode != '') {
            this.eanCode = this.product.barcode;
        }

        this.chooseDefaultImage();

        this.ProductViewService.setProduct(this.product);
        this.ProductViewService.setPrice(this.price);

        if (this.complementaryProducts) {
            this.selectedComplementaryProduct = this.$filter('orderBy')(this.complementaryProducts, 'price_gros', true).pop();
        }

        if (this.product.type == 2) {
            this.images.push({
                default: false,
                file_id: 0,
                type: 'voucher',
                url: '/templates/rowerystylowenew/assets/img/upload-voucher-image.svg'
            });
        }

        // Check if product has variants
        if (!this.variants || this.variants.length < 1) return;

        this.price.from = true;
        this.price.price_gros = parseFloat(this.product.min_price);
        this.price.price_net = parseFloat(this.product.min_price) / (1 + this.product.tax / 100);

        this.availability.name = null;
        this.availability.quantity = null;
        this.productCode = null;
        this.eanCode = null;

        if (this.attributesToFilter && this.attributesToFilter.length) {
            for (const attributeId of this.attributesToFilter) {
                this.selectedAttributes[attributeId] = -1;
            }
        }

        let possibleAttributes = new Map();

        if (this.attributesToFilter && this.attributesToFilter.length) {
            this.variants.forEach(variant => {
                if (!variant.attributes || variant.attributes.length === 0) {
                    return;
                }
                variant.attributes.forEach(attribute => {
                    if (this.attributesToFilter.indexOf(parseInt(attribute.attribute_id)) !== -1) {
                        possibleAttributes.set(attribute.attribute_id, '1');
                    }
                });
            });

            // Remove invalid variants

            this.variants = this.variants.filter(variant => {
                if (!variant.attributes && this.attributes.length > 0) {
                    return false;
                }
                let variantIsValid = true;
                for (const attributeId of possibleAttributes.keys()) {
                    variantIsValid = variantIsValid && this.variantHasAttribute(variant, attributeId);
                }
                return variantIsValid;
            });
        }

        //

        for (const variant of this.variants) {
            variant.displayed_availability = variant.displayed_availability.replace(/([0-9]{4}-[0-9]{2}-[0-9]{2})/gm, '<span class="text-nowrap">$1</span>');

            if (variant.color_id && parseInt(variant.color_id) != 0) {
                if (!this.colors.has(parseInt(variant.color_id))) {
                    this.colors.set(parseInt(variant.color_id), {
                        name: variant.color.name,
                        hex: variant.color.hex,
                        hex_additional: variant.color.hex_additional || null,
                        bright: this.isColorBright(variant.color.hex),
                        available: (parseInt(variant.can_buy) == 1)
                    });
                } else {
                    const color = this.colors.get(parseInt(variant.color_id));

                    if (parseInt(variant.can_buy) === 1 && !color.available) {
                        color.available = true;
                    }
                }
            }

            if (!variant.attributes || variant.attributes.length < 1) continue;

            for (const attribute of variant.attributes) {
                const attributeId = parseInt(attribute.attribute_id);

                if (this.attributesToFilter.indexOf(attributeId) < 0) {
                    continue;
                }

                const value = {
                    id: parseInt(attribute.value_id),
                    name: attribute.value_name,
                    available: true,
                    order: parseInt(attribute.sort),
                    description: attribute.value_description
                }

                if (this.attributes.has(attributeId)) {
                    const values = this.attributes.get(attributeId).values;
                    const matches = values.filter(v => v.id == value.id);

                    if (matches.length > 0) continue;

                    values.push(value);
                } else {
                    this.attributes.set(attributeId, {
                        name: attribute.attribute_name,
                        values: [value]
                    });
                }
            }
        }

        if (this.attributes.get(14)) {
            this.ProductViewService.setFrameSizes(this.attributes.get(14).values);
        }

        // Add attributes and colors to the filters

        this.filters.push({type: 'color', id: 0, data: this.colors});
        for (const attribute of this.attributes) {
            this.filters.push({type: 'attribute', id: attribute[0], data: attribute[1]});
        }

        // Sort the filters by a filters.Order object data

        this.filters.sort((filter1, filter2) => {
            let filters = [{filter: filter1, order: -1}, {filter: filter2, order: -1}];
            for (const filter of filters) {
                for (const [index, filterOrder] of this.filtersOrder.entries()) {
                    if (filterOrder.type === filter.filter.type && filterOrder.id === filter.filter.id) {
                        filter.order = index;
                    }
                }
            }
            if (filters[0].order > filters[1].order) {
                return 1;
            }

            return -1;
        });

        if (this.filters && this.filters.length > 0) {
            this.filters[this.filters.length - 1].last = 1;
        }

        if (this.selectedVariant) {
            const matches = this.variants.filter(variant => variant.id == this.selectedVariant);

            this.selectVariant(matches[0]);

            if (matches[0].color_id) {
                this.selectedColorId = parseInt(matches[0].color_id);
            }

            for (const attributeId of this.attributesToFilter) {
                const attributes = matches[0].attributes.filter(attribute => parseInt(attribute.attribute_id) == attributeId);

                if (!attributes || attributes.length < 1) continue;

                this.selectedAttributes[attributeId.toString()] = attributes[0].value_id.toString();
            }
        }

        this.checkAttributesAvaibilityForFrame();

        if (!this.selectedVariant) {
            this.checkAttributesMatching();
        }

        this.checkAttributesAvaibility();

        // Fallback to product/variant ID
        let productCode = this.product.id;

        if (this.selectedVariant) {
            productCode = this.selectedVariant.id;
        }

        if (this.productCode) {
            productCode = this.productCode;
        }

        console.log(`gtag::event::view_item -> wyświetlenie -> ${productCode}`);

        let productPrice = this.price.price_gros.toString();
        const productName = this.name;
        const productCategoryName = this.product.category_name;

        if (typeof window.fbq !== 'undefined') {
            const itemPrice = Number(productPrice.replace(/(\d+),(\d+).*/, '$1.$2') || 0);

            window.fbq('track', 'ViewContent', {
                content_ids: [String(productCode)],
                contents: [{
                    id: String(productCode),
                    quantity: 1,
                    item_price: itemPrice
                }],
                content_name: productName,
                content_type: 'product',
                content_category: productCategoryName || '',
                currency: 'PLN',
                value: itemPrice
            }, {
                eventID: 'view_content_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10)
            });
        }

        if (typeof window.gtag === 'undefined') {
            return;
        }

        window.gtag('event', 'view_item', {
            currency: 'PLN',
            value: parseFloat(productPrice.replace(/(\d+),(\d+).*/, '$1.$2')),
            items: [
                {
                    item_id: productCode,
                    item_name: productName,
                    item_category: productCategoryName,
                    price: parseFloat(productPrice.replace(/(\d+),(\d+).*/, '$1.$2'))
                }
            ]
        });

    }

    isColorBright(hex) {
        let bright = true;
        hex = hex.replace('#', '');

        while (hex !== '') {
            bright = bright && parseInt(hex.slice(0, 2), 16) > 225;
            hex = hex.slice(2);
        }

        return bright;
    }

    getFrameDescription(value, attributeId = 0) {
        const frameName = /^\d+$/.test(value.name) ? parseInt(value.name) : value.name;

        if (this.filtersOmitDescription.indexOf(attributeId) >= 0) {
            return null;
        }

        let frameDescription = null;

        if (value && value.description && !(typeof (frameName) === 'number' && this.framesDescription[frameName])) {
            frameDescription = value.description.replace(/<[^>]*>?/gm, '').trim();
        }

        if (!frameDescription && this.framesDescription && typeof(this.framesDescription[frameName]) !== 'undefined') {
            frameDescription = this.framesDescription[frameName];
        }

        if (frameDescription) {
            return '<span class="text-muted"><small>(' + frameDescription + ')</small></span>'
        }

        return null;
    }

    attributeValuesHasDescription(attribute, attributeId) {
        if (this.filtersOmitDescription.indexOf(attributeId) >= 0) {
            return false;
        }

        return !!attribute.values.find(value => !!(value.description && !value.hidden && value.available));
    }

    getVariantBySelectedAttributes(selectedAttributes) {

    }

    variantHasAttribute(variant, attributeId) {
        if (!variant.attributes || variant.attributes.length === 0) {
            return false;
        }
        let hasAttribute = false;

        variant.attributes.forEach((attribute) => {
            if (parseInt(attribute.attribute_id) === parseInt(attributeId)) {
                hasAttribute = true;
            }
        });

        return hasAttribute;
    }

    complementaryProductChanged() {
        this.calculatePrice();
    }

    getComplementaryProductDescription(complementaryProduct) {
        let description = '';
        if (complementaryProduct.description) {
            description = '<span class="text-muted"><small>(' + complementaryProduct.description + ')</small></span>';
        }

        description += '<br/>' + complementaryProduct.price_gros + ' zł';

        return description;
    }

    selectColorAttribute(id) {
        this.selectedColorId = id;
        this.checkAttributesMatching('color', 0);
        this.checkAttributesAvaibilityForFrame();
        this.checkAttributesAvaibility();
    }

    selectAttribute(attributeId, valueId) {
        this.selectedAttributes[attributeId] = valueId;
        this.checkAttributesMatching('attribute', attributeId);
        this.checkAttributesAvaibilityForFrame();
        this.checkAttributesAvaibility();
    }

    checkAttributesMatching(attributeType, attributeId = null, step = 1, simulation = false) {
        let selectedAttributes = {};
        let validVariants = this.variants;

        let thisSelectedAttributes = simulation ? this.selectedAttributesSimulation : this.selectedAttributes;

        for (const [key, value] of Object.entries(thisSelectedAttributes)) {
            if (value > 0) {
                selectedAttributes[key] = value;
            }
        }

        validVariants = this.variants.filter(variant => {
            let valid = true;
            if (this.selectedColorId && parseInt(variant.color_id) !== parseInt(this.selectedColorId)) {
                return false;
            }
            for (const [attribute_id, attribute_value] of Object.entries(selectedAttributes)) {
                valid = valid && this.variantHasAttributeValue(variant, attribute_id, attribute_value);
            }
            return valid;
        });

        if (validVariants.length === 0) {
            // Matching variants not found - remove selected attribute by attribute order and search again
            let lastMatchedFilter = this.filtersOrder.find(filter => filter.type === attributeType && filter.id === attributeId);
            let tmpFiltersOrder = this.filtersOrder.filter(filter => filter !== lastMatchedFilter);
            tmpFiltersOrder = tmpFiltersOrder.reverse();
            if (lastMatchedFilter) {
                tmpFiltersOrder.push(lastMatchedFilter);
            }

            const filterToRemove = tmpFiltersOrder.find(filter => {
                switch (filter.type) {
                    case 'color':
                        if (this.selectedColorId) {
                            return true;
                        }
                        break;
                    case 'attribute':
                        if (selectedAttributes[filter.id]) {
                            return true;
                        }
                        break;
                }
            });

            if (filterToRemove) {
                if (filterToRemove.type === 'color') {
                    if (!simulation) {
                        this.selectedColorId = null;
                    }
                } else {
                    thisSelectedAttributes[filterToRemove.id] = -1;
                }
                if (filterToRemove && step < 20) {
                    return this.checkAttributesMatching(attributeType, attributeId, ++step, simulation);
                }
            }
        }

        let bestMatches = validVariants;

        this.attributes.forEach((attribute, attributeId) => {
            let firstMatchedValue = null;
            let attributeValues = [];
            attribute.values.forEach(value => {
                attributeValues.push({name: value.name, id: value.id});
            });
            attributeValues = attributeValues.sort((value1, value2) => {
                return value1.name > value2.name ? 1 : -1;
            });

            attributeValues.forEach(value => {
                bestMatches = bestMatches.filter(variant => {
                    let filter = true;
                    variant.attributes.forEach(variantAttribute => {
                        if (parseInt(attributeId) === parseInt(variantAttribute.attribute_id)
                            && parseInt(value.id) === parseInt(variantAttribute.value_id)) {
                            if (!firstMatchedValue || firstMatchedValue === parseInt(variantAttribute.value_id)) {
                                firstMatchedValue = parseInt(variantAttribute.value_id);
                            } else {
                                filter = false;
                            }
                        }
                    });
                    return filter;
                })
            })
        })

        if (bestMatches) {
            validVariants = bestMatches;
        }

        validVariants[0].attributes.forEach(attribute => {
            if (this.attributesToFilter.includes(parseInt(attribute.attribute_id))) {
                thisSelectedAttributes[parseInt(attribute.attribute_id)] = attribute.value_id.toString();
            }
        });

        if (simulation) {
            return validVariants[0];
        }

        this.selectedColorId = parseInt(validVariants[0].color_id);
        this.selectVariant(validVariants[0]);
    }

    variantHasAttributeValue(variant, attributeId, attributeValue) {
        let valueExists = false;

        variant.attributes.forEach(attribute => {
            if (parseInt(attribute.attribute_id) === parseInt(attributeId) &&
                parseInt(attribute.value_id) === parseInt(attributeValue)) {
                valueExists = true;
            }
        });

        return valueExists;
    }


    showSizeTable() {
        const modalRef = this.ModalService.add(
            'Tabela rozmiarów marki ' + this.product.producer,
            `<div class="product-table-size">${this.sizeTable}</div>`,
            null,
            true,
            'table-size-modal'
        );

        modalRef.open();
    }

    showFrameSizeDescription() {
        const modalRef = this.ModalService.add(
            'Jak dobrać rozmiar ramy',
            unescape(this.howToChooseFrameSize).replace(/\\"/g, '"'),
            null,
            true,
            'frame-size-modal'
        );

        modalRef.open();
    }

    showShippingPrices() {
        const modalRef = this.ModalService.add(
            'Informacje o kosztach wysyłki',
            `<product-view-shipping-prices prices="${escape(JSON.stringify(this.shipmentModal))}" information="${escape(this.informationOnShippingCosts)}"></product-view-shipping-prices>`,
            null,
            true,
            'shipping-prices-modal'
        );

        modalRef.open();
    }

    showStationaryStoreAvailabilities() {
        let productName = '';

        if (this.selectedVariant) {
            let productNameArray = [];
            const variant = this.variants.find(variant => variant.id === this.selectedVariant);
            variant.attributes.forEach(attribute => {
                productNameArray.push(attribute.attribute_name + ': ' + attribute.value_name);
            });
            if (variant.color) {
                productNameArray.push('Kolor: ' + variant.color.name);
                productName = productNameArray.join(', ');
            }
        } else {
            productName = this.product.name;
        }

        const modalRef = this.ModalService.add(
            null,
            `<product-view-stationary-store-availabilities availabilities="${escape(JSON.stringify(this.stationaryStoreAvailabilites))}" variant-id="${this.selectedVariant}" can-buy="${this.canBuy}" product-name="${productName}"></product-view-stationary-store-availabilities>`,
            (action) => {
                if (action && action === 'buy') {
                    this.buy();
                } else if (action && action === 'availabilityQuestion') {
                    if (this.variants && this.variants.length > 0 && this.selectedVariant) {
                        this.availabilityQuestion(this.selectedVariant);
                    } else {
                        this.availabilityQuestion();
                    }
                }
            }
        );

        modalRef.open();
    }

    availabilityQuestion(variantId) {
        let productName;

        if (variantId) {
            const matches = this.variants.filter(variant => variant.id == variantId);

            if (typeof matches[0] !== 'undefined') {
                productName = `${this.product.name} - ${matches[0].name}`;
            } else {
                productName = `${this.product.name} (wariant: ${variantId})`;
            }
        } else {
            productName = this.product.name;
        }

        const modalRef = this.ModalService.add(
            'Powiadom mnie gdy produkt się pojawi',
            `<product-view-availability-question product-id="${this.product.id}" variant-id="${variantId}" product-name="'${productName}'" attribute-id="0" attribute-value-id="0"></product-view-availability-question>`,
            null, true, null, 'modal-sm'
        );

        modalRef.open();
    }

    availabilityQuestionAttribute(attributeId, valueId, attributeName, valueName) {
        let availableVariants = this.variants;

        if (this.selectedColorId) {
            availableVariants = availableVariants.filter(variant => parseInt(variant.color_id) == this.selectedColorId);
        }

        const availableVariantsForAttribute = availableVariants.filter(
            variant => {
                const attributes = variant.attributes.filter(attribute => parseInt(attribute.attribute_id) == attributeId);

                if (!attributes || attributes.length < 1) {
                    return false;
                }

                if (parseInt(attributes[0].value_id) != valueId) {
                    return false;
                }

                return true;
            }
        );

        if (availableVariantsForAttribute.length >= 1) {
            const modalRef = this.ModalService.add(
                'Powiadomienie o dostępności',
                `<product-view-availability-question product-id="${this.product.id}" variant-id="${availableVariantsForAttribute[0].id}" product-name="'${this.product.name} (wariant: ${availableVariantsForAttribute[0].id})'" attribute-id="0" attribute-value-id="0"></product-view-availability-question>`
            );

            modalRef.open();
        } else {
            const modalRef = this.ModalService.add(
                'Powiadomienie o dostępności',
                `<product-view-availability-question product-id="${this.product.id}" variant-id="0" product-name="'${this.product.name}'" attribute-id="${attributeId}" attribute-value-id="${valueId}" attribute-name="'${attributeName}'" attribute-value-name="'${valueName}'"></product-view-availability-question>`
            );

            modalRef.open();
        }
    }

    availabilityQuestionColor(colorId, colorName) {
        const modalRef = this.ModalService.add(
            'Powiadomienie o dostępności',
            `<product-view-availability-question product-id="${this.product.id}" variant-id="0" product-name="'${this.product.name} - kolor: ${colorName}'" attribute-id="0" attribute-value-id="${colorId}" attribute-name="'Kolor'" attribute-value-name="'${colorName}'"></product-view-availability-question>`
        );

        modalRef.open();
    }

    checkAttributesAvaibilityForFrame() {
        let availableVariants = this.variants;

        // Don't display colors not available for the selected frame type
        let attributeValues = new Map();
        let attributesColors = new Map();

        // Get all colors available for the each of an attribute values
        availableVariants.forEach(variant => {
            variant.attributes.forEach(variantAttribute => {
                // Store the colors available for a specific variant values
                const attribute_id = parseInt(variantAttribute.attribute_id);
                const value_id = parseInt(variantAttribute.value_id);

                let variantAttributeColors = attributesColors.get(attribute_id);
                if (!variantAttributeColors) {
                    variantAttributeColors = new Map();
                }
                let colorsList = variantAttributeColors.get(value_id);
                if (!colorsList) {
                    colorsList = new Map();
                }

                colorsList.set(parseInt(variant.color_id), parseInt(variant.color_id));
                variantAttributeColors.set(value_id, colorsList);
                attributesColors.set(attribute_id, variantAttributeColors);

                // Store the attributes available for a specific variant values
                let variantAttributeValues = attributeValues.get(attribute_id);
                if (!variantAttributeValues) {
                    variantAttributeValues = new Map();
                }
                let otherAttributes = variantAttributeValues.get(value_id);
                if (!otherAttributes) {
                    otherAttributes = new Map();
                }

                variant.attributes.forEach(otherVariantAttribute => {
                    const other_attribute_id = parseInt(otherVariantAttribute.attribute_id);
                    const other_value_id = parseInt(otherVariantAttribute.value_id);

                    if (other_attribute_id === attribute_id) {
                        return;
                    }

                    let otherAttributesValues = otherAttributes.get(other_attribute_id);

                    if (!otherAttributesValues) {
                        otherAttributesValues = new Map();
                    }

                    otherAttributesValues.set(other_value_id, other_value_id);
                    otherAttributes.set(other_attribute_id, otherAttributesValues);
                });

                variantAttributeValues.set(value_id, otherAttributes);
                attributeValues.set(attribute_id, variantAttributeValues);
            });
        });

        if (this.selectedAttributes[this.frameAttributeId] && this.selectedAttributes[this.frameAttributeId] > 0) {
            // Hide colors not available for the selected frame type
            const selectedFrameSize = parseInt(this.selectedAttributes[this.frameAttributeId]);
            const selectedFrameColors = attributesColors.get(this.frameAttributeId).get(selectedFrameSize);
            let availableColors = [];

            if (!selectedFrameColors) {
                return;
            }

            this.colors.forEach((color, color_id) => {
                color.hidden = !selectedFrameColors.has(color_id);
                if (selectedFrameColors.has(color_id)) {
                    availableColors.push(color_id);
                }
            });

            // Hide attributes not available for the selected frame type
            const availableAttributesValues = attributeValues.get(this.frameAttributeId).get(selectedFrameSize);

            this.attributes.forEach((attribute, attribute_id) => {

                if (attribute_id === this.frameAttributeId) {
                    return;
                }

                const availableValues = availableAttributesValues.get(attribute_id);

                for (let value of attribute.values) {
                    value.hidden = !availableValues.has(value.id);
                }
            });

        } else {
            this.colors.forEach((color, color_id) => {
                color.hidden = false;
            });
            this.attributes.forEach((attribute, attribute_id) => {
                for (let value of attribute.values) {
                    value.hidden = false;
                }
            });
        }

    }

    checkAttributesAvaibility() {
        let availableVariants = this.variants; //this.variants.filter(variant => parseInt(variant.can_buy) == 1);
        let tmpAvailableVariants = availableVariants;

        if (this.selectedColorId) {
            tmpAvailableVariants = availableVariants = availableVariants.filter(variant => parseInt(variant.color_id) == this.selectedColorId);
        }

        this.availableAttributes = {};

        // Przeglądamy wszystkie atrybuty
        for (let [attributeId, attribute] of this.attributes) {

            let allMatchesForAttribute = [];

            // Przeglądamy wartości atrybutu
            for (const value of attribute.values) {

                // Wybieramy tylko te warianty, których atrybut "attributeId" ma wartość "value"
                const availableVariantsForAttributeValue = availableVariants.filter(
                    variant => {

                        const attributes = variant.attributes.filter(
                            attribute => parseInt(attribute.attribute_id) == attributeId
                        );

                        if (!attributes || attributes.length < 1) return false;

                        if (parseInt(attributes[0].value_id) != value.id) return false;

                        return true;
                    }
                );

                // Warianty, które mają te same wartości
                allMatchesForAttribute = allMatchesForAttribute.concat(availableVariantsForAttributeValue);

                // Wartość jest dostępna, jeżeli istnieją warianty, które mają
                value.available = (availableVariantsForAttributeValue.length > 0);

                if (this.selectedAttributes[attributeId] == value.id && !value.available) {
                    this.selectedAttributes[attributeId] = -1;
                }
            }

            if (this.selectedAttributes[attributeId] > 0) {
                availableVariants = availableVariants.filter(
                    variant => {
                        const attributes = variant.attributes.filter(attribute => parseInt(attribute.attribute_id) == attributeId);

                        if (!attributes || attributes.length < 1) return false;

                        if (parseInt(attributes[0].value_id) != this.selectedAttributes[attributeId]) return false;

                        return true;
                    }
                );
            } else {
                availableVariants = allMatchesForAttribute;

                const attributes = allMatchesForAttribute[0].attributes.filter(attribute => parseInt(attribute.attribute_id) == attributeId);

                if (!attributes || attributes.length < 1) return;

                this.selectedAttributes[attributeId] = attributes[0].value_id;
            }
        }

        let validAttributes = {};

        // Remove invalid attributes combinations
        this.attributes.forEach((attribute, attributeId) => {
            let matching = {};
            for (const [selectedAttributeId, selectedAttributeValue] of Object.entries(this.selectedAttributes)) {
                if (selectedAttributeValue !== -1 && selectedAttributeId != attributeId && this.filtersOmitAvailability.indexOf(parseInt(selectedAttributeId)) === -1 ) {
                    matching[selectedAttributeId] = selectedAttributeValue;
                }
            }

            tmpAvailableVariants.forEach((variant) => {
                let match = 0;
                variant.attributes.forEach(attribute => {
                    if (matching[attribute.attribute_id] == attribute.value_id) {
                        match++;
                    }
                });
                if (match === Object.keys(matching).length) {
                    variant.attributes.forEach(attribute => {
                        if (!validAttributes[attribute.attribute_id]) {
                            validAttributes[attribute.attribute_id] = {};
                        }
                        validAttributes[attribute.attribute_id][attribute.value_id] = 1;
                    });
                }
            });
        });

        this.attributes.forEach((attribute, attributeId) => {
            attribute.values.forEach(value => {
                if (validAttributes[attributeId] && !validAttributes[attributeId][value.id]) {
                    value.available = false;
                }
            });
        });

        this.matchingVariantsForAttributeValue = {};

        this.attributes.forEach((attribute, attributeId) => {
            // Look up for the variants matching selected attribute values for each of attributes and values
            let otherSelectedAttributes = [];
            for (const [selectedAttributeId, valueId] of Object.entries(this.selectedAttributes)) {
                if (this.filtersOmitAvailability.indexOf(parseInt(selectedAttributeId)) !== -1) {
                    continue;
                }
                if (attributeId !== parseInt(selectedAttributeId) && valueId > 0) {
                    otherSelectedAttributes.push({attribute_id: selectedAttributeId, value_id: valueId});
                }
            }

            this.matchingVariantsForAttributeValue[attributeId] = {};

            tmpAvailableVariants.forEach(variant => {
                let matches = true;
                let attributeValue = null;
                variant.attributes.forEach(attribute => {
                    otherSelectedAttributes.forEach(otherSelectedAttribute => {
                        if (attribute.attribute_id === otherSelectedAttribute.attribute_id && attribute.value_id !== otherSelectedAttribute.value_id) {
                            matches = false;
                        }
                    });
                    if (parseInt(attribute.attribute_id) === attributeId) {
                        attributeValue = attribute.value_id;
                    }
                });
                if (matches) {
                    if (!this.matchingVariantsForAttributeValue[attributeId][attributeValue]) {
                        this.matchingVariantsForAttributeValue[attributeId][attributeValue] = [];
                    }
                    this.matchingVariantsForAttributeValue[attributeId][attributeValue].push(variant);
                }
            });
        });

        if (!this.selectedVariant) {
            this.selectVariant(availableVariants[0]);
        }
    }

    getInfoForAttributeValue(attributeId, valueId, lastFilter) {
        if (!lastFilter && attributeId !== 14) {
            return null;
        }

        let matchingVariant = null;

        if (this.matchingVariantsForAttributeValue[attributeId]
            && this.matchingVariantsForAttributeValue[attributeId][valueId]
        ) {
            if (this.matchingVariantsForAttributeValue[attributeId][valueId].length > 1) {
                matchingVariant = this.matchingVariantsForAttributeValue[attributeId][valueId].find(variant => parseInt(variant.id) === parseInt(this.selectedVariant));
                if (!matchingVariant) {
                    this.selectedAttributesSimulation = Object.assign({}, this.selectedAttributes);
                    this.selectedAttributesSimulation[attributeId] = valueId;
                    matchingVariant = this.checkAttributesMatching('attribute', attributeId, 1, true);
                }
            }

            if (!matchingVariant) {
                matchingVariant = this.matchingVariantsForAttributeValue[attributeId][valueId][0];
            }
            return '<span class="availability-' + this.getAvailability(matchingVariant.avail_id).color + '">' + matchingVariant.displayed_availability + '</span>';
        }
        return null;
    }

    getInfoForComplementaryProduct() {
        return '<span class="availability-green">dostępny</span>';
    }

    getInfoForVariant(variant) {
        return '<span class="availability-' + this.getAvailability(variant.avail_id).color + '">' + variant.displayed_availability + '</span>';
    }

    chooseDefaultImage() {
        if (!this.images || this.images.length < 1) return null;

        let defaultProductImage = this.images.filter(
            image => !image.variant_id && image.default
        )[0];

        if (defaultProductImage === undefined) {
            defaultProductImage = this.images[0];
        }

        if (!this.selectedVariant) {
            this.currentImage = defaultProductImage;
            return this.currentImage;
        }

        const variantsDefaultImage = this.images.filter(
            image => image.variant_id == this.selectedVariant && image.default
        );

        if (variantsDefaultImage.length < 1) {
            this.currentImage = defaultProductImage;
            return this.currentImage;
        }

        this.currentImage = variantsDefaultImage[0];

        return this.currentImage;
    }

    changeCurrentImage(url, image) {
        if (this.product.type == 2 && image.data.type !== 'voucher') {
            this.voucher.custom_image = null;
            this.voucher.file_id = image.data.file_id;
            this.voucher.file_url = url;
        } else if (this.product.type == 2 && image.data.type === 'voucher') {
            this.voucher.custom_image = image.customData;
            this.voucher.file_id = null;
            this.voucher.file_url = null;
        }

        const images = this.images.filter(
            image => image.url == url
        );

        if (images.length < 1) return;

        this.currentImage = images[0];
    }

    setVoucherImage(imageData) {
        this.voucher.custom_image = imageData;
    }

    test(fid) {
        alert(fid);
    }

    calculatePrice() {
        const complementaryProductPriceGros = this.selectedComplementaryProduct ? this.selectedComplementaryProduct.price_gros : 0;
        const complementaryProductPriceNet = this.selectedComplementaryProduct ? this.selectedComplementaryProduct.price_net : 0;

        if (!this.variants || this.variants.length < 1) {
            this.price = {
                from: false,
                catalog_price: this.product.catalog_price,
                price_old_gros: parseFloat(this.product.old_price) + parseFloat(complementaryProductPriceGros),
                price_gros: parseFloat(this.product.price_gros) + parseFloat(complementaryProductPriceGros),
                price_net: parseFloat(this.product.price_net) + parseFloat(complementaryProductPriceNet),
                omnibus_lowest_price: this.product.omnibus_lowest_price
            };
        } else if (this.selectedVariant) {
            const selectedVariant = this.variants.find(variant => variant.id === this.selectedVariant);

            this.price = {
                from: false,
                catalog_price: selectedVariant.catalog_price,
                price_old_gros: selectedVariant.price_old_gros + complementaryProductPriceGros,
                price_gros: selectedVariant.price_gros + complementaryProductPriceGros,
                price_net: selectedVariant.price_net + complementaryProductPriceNet,
                omnibus_lowest_price: selectedVariant.omnibus_lowest_price
            };
        } else {
            this.price = {
                from: true,
                catalog_price: this.product.catalog_price,
                price_old_gros: parseFloat(this.product.old_price) + parseFloat(complementaryProductPriceGros),
                price_gros: parseFloat(this.product.min_price) + parseFloat(complementaryProductPriceGros),
                price_net: parseFloat(parseFloat(this.product.min_price) / (1 + this.product.tax / 100)) + parseFloat(complementaryProductPriceNet),
                omnibus_lowest_price: this.product.omnibus_lowest_price
            };
        }

        this.ProductViewService.setPrice(this.price);
    }

    getPercentageDiffForOmnibusLowerPrice(omnibus_lowest_price, price_gros) {
        let diff = Math.round(((omnibus_lowest_price - price_gros) / omnibus_lowest_price) * 100);

        if (diff > 0) {
            return '+' + diff + '%';
        } else {
            return diff + '%';
        }
    }

    selectVariantById(variantId) {
        const foundVariant = this.variants.find(variant => variant.id === variantId);
        this.selectVariant(foundVariant);
    }

    selectVariant(variant) {
        if (!variant || !variant.can_buy) {
            this.calculatePrice();
            this.availability = {
                name: null,
                quantity: this.product.quantity
            };
            this.productCode = null;
            this.eanCode = null;
            this.selectedVariant = null;
            this.chooseDefaultImage();

            this.updateMetaDataOnSelectVariant(null, 'https://www.rowerystylowe.pl/' + this.defaultUrl);

            return;
        }

        let segments = this.$location.path().split('/');
        let variantRegexPattern = /^w-[0-9]+$/gm;
        let tmpUrl = '';

        if (variantRegexPattern.test(segments[segments.length - 2])) {
            segments[segments.length - 2] = 'w-' + variant.id;
            segments[segments.length - 1] = variant.slug;

            let path = segments.join('/');

            this.$location.path(path);

            tmpUrl = path;
        } else {
            let path = `${this.$location.path()}/w-${variant.id}/${variant.slug}`;

            this.$location.path(path);

            tmpUrl = path;
        }

        this.selectedVariant = variant.id;

        this.chooseDefaultImage();
        this.calculatePrice();
        this.productCode = variant.product_code;
        this.eanCode = variant.barcode;
        this.availability = {
            id: variant.avail_id,
            name: variant.displayed_availability,
            quantity: variant.quantity
        };

        this.ProductViewService.setVariant(variant);

        this.updateMetaDataOnSelectVariant(variant, 'https://www.rowerystylowe.pl' + tmpUrl);
    }

    updateMetaDataOnSelectVariant(variant, url) {
        const metaTitle = this.defaultMetaTitle.prefix + (variant !== null ? ' ' + variant.name : '') + this.defaultMetaTitle.suffix;
        this.$window.document.getElementsByTagName('title')[0].text = metaTitle;
        this.$window.document.querySelectorAll('meta[property="og:title"]')[0].content = metaTitle;
        this.$window.document.querySelectorAll('meta[name="twitter:title"]')[0].content = metaTitle;

        const metaDescription = this.defaultMetaDescription.prefix + (variant !== null ? ' ' + variant.name : '') + this.defaultMetaDescription.suffix;
        this.$window.document.querySelectorAll('meta[name="description"]')[0].content = metaDescription;
        this.$window.document.querySelectorAll('meta[property="og:description"]')[0].content = metaDescription;
        this.$window.document.querySelectorAll('meta[name="twitter:description"]')[0].content = metaDescription;

        this.$window.document.querySelectorAll('meta[property="og:url"]')[0].content = url;

        this.$window.document.querySelectorAll('link[rel="canonical"]')[0].href = url;

        this.$window.document.querySelectorAll('#breadcrumbs ol > li:last-of-type a')[0].href = url;

        this.$window.document.querySelectorAll('.navbar-brand')[0].title = this.product.name + (variant !== null ? ' ' + variant.name : '');

        prodid = 'p' + this.product.id + 'v' + (variant !== null ? variant.id : '0');

        if (this.$window.document.querySelectorAll('#product-attributes h2')[0] !== undefined) {
            this.$window.document.querySelectorAll('#product-attributes h2')[0].innerText = 'Specyfikacja ' + this.product.name + (variant !== null ? ' ' + variant.name : '');
        }

        if (this.$window.document.querySelectorAll('#product-reviews h4')[0] !== undefined) {
            this.$window.document.querySelectorAll('#product-reviews h4')[0].innerText = this.product.name + (variant !== null ? ' ' + variant.name : '') + ' opinie';
        }
    }

    onSelectNotAvailableVariant(variantId) {
        this.availabilityQuestion(variantId);
    }

    increaseQuantity() {
        this.quantity = parseInt(this.quantity) + 1;
    }

    decreaseQuantity() {
        this.quantity = Math.max(0, parseInt(this.quantity) - 1);
    }

    transformUrlEncoded(data) {
        return this.$httpParamSerializer(data);
    }

    parseFloat(val) {
        return parseFloat(val);
    }

    ratingFile(star) {
        return `templates/rowerystylowenew//dist/spritemap.svg?v=202406200#sprite-${star}`;
    }

    getAvailability(availabilityId) {
        return this.availabilities.find(availability => availability.avail_id === availabilityId);
    }

    countAvailableAttributeValues(attributeValues) {
        return attributeValues.filter(attributeValue => !attributeValue.hidden && attributeValue.available).length;
    }

    negotiatePrice() {
        let productName = this.product.name.trim();

        if (this.selectedVariant) {
            let productNameArray = [];

            const variant = this.variants.find(variant => variant.id === this.selectedVariant);
            variant.attributes.forEach(attribute => {
                productNameArray.push(attribute.attribute_name + ': ' + attribute.value_name);
            });

            if (variant.color) {
                productNameArray.push('Kolor: ' + variant.color.name);
            }

            if (productNameArray.length > 0) {
                productName = productName + ', ' + productNameArray.join(', ');
            }
        }

        const modalRef = this.ModalService.add(
            null,
            `<product-view-negotiate-price product-id="${this.product.id}" variant-id="${this.selectedVariant}" product-name="${productName}"></product-view-negotiate-price>`
        );

        modalRef.open();
    }

    buy() {
        if (this.product.type == 2) {
            this.voucherForm1.$setSubmitted();
            this.voucherForm2.$setSubmitted();

            if (!this.voucherForm1.$valid || !this.voucherForm2.$valid || !this.voucher.custom_image && !this.voucher.file_id) {
                this.SnackbarService.add('Popraw błędy w formularzu', 'error', true, 3000);
                return;
            }
        }

        this.loading = true;

        let variant = null;
        let complementaryProducts = [];

        if (this.selectedVariant) {
            variant = parseInt(this.selectedVariant);
        }

        if (this.selectedComplementaryProduct) {
            complementaryProducts.push(this.selectedComplementaryProduct.id);
        }

        this.$http.post(
            '/ajax/checkout/add-to-cart',
            {
                productId: parseInt(this.product.id),
                variantId: variant,
                quantity: parseInt(this.quantity),
                complementaryProductId: complementaryProducts,
                voucher: this.product.type == 2 ? {...this.voucher, ...{custom_image_crop: this.CropService.data}} : null
            }
        ).then(
            (response) => {
                this.loading = false;

                if (response.data.message && response.data.message.type != 'success') {

                    const message = response.data.message.content;

                    this.SnackbarService.add(message, 'error', true, 3000);

                    return;
                }

                const message = response.data.message.content;

                this.CartService.load().then(() => {
                    const modalRef = this.ModalService.add(
                        'Produkt dodany do koszyka',
                        `<div class="product-add-to-cart-modal">
                            <img ng-src="${this.defaultPhoto.url}" alt="${this.name}" />
                            <p>${message}</p>
                        </div>
                        <div class="button-container">
                            <button class="btn btn-secondary" type="button" ng-click="$ctrl.close()">Wracam do zakupów</button>
                            <a class="btn btn-primary" href="/koszyk">Przejdź do koszyka ( <cart-count count="0"></cart-count> )</a>
                        </div>
                        <section id="quick-buy-container" style="text-align: center; margin-top: 30px;" ng-if="$ctrl.hasSimilarProductsFor(${this.product.id})">
                            <div class="container-xl">
                                <cart-quick-buy
                                    limit-items="6"
                                    product-id="${this.product.id}"></cart-quick-buy>
                            </div>
                        </section>
                        <style>
                        #quick-buy-container>.container-xl .product-slide {
                            padding-bottom: 0;
                        }
                        </style>`,
                        null,
                        true,
                        'add-to-cart-modal',
                        'modal-lg'
                    );

                    modalRef.open();
                });

                // Fallback to product/variant ID
                let productCode = this.product.id;

                if (variant) {
                    productCode = variant;
                }

                if (this.productCode) {
                    productCode = this.productCode;
                }

                console.log(`gtag::event::add_to_cart -> dodanie -> ${productCode}`);

                let productPrice = response.data.message.product_price.toString();
                const productName = this.name;
                const productCategoryName = this.product.category_name;
                const productQuantity = parseInt(this.quantity);

                if (typeof window.fbq !== 'undefined') {
                    const itemPrice = Number(productPrice.replace(/(\d+),(\d+).*/, '$1.$2') || 0);

                    window.fbq('track', 'AddToCart', {
                        content_ids: [String(productCode)],
                        contents: [{
                            id: String(productCode),
                            quantity: Number(productQuantity || 1),
                            item_price: itemPrice
                        }],
                        content_name: productName,
                        content_type: 'product',
                        currency: 'PLN',
                        value: itemPrice * Number(productQuantity || 1)
                    }, {
                        eventID: 'add_to_cart_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10)
                    });
                }

                if (typeof window.gtag === 'undefined') {
                    return;
                }

                window.gtag('event', 'add_to_cart', {
                    currency: 'PLN',
                    value: parseFloat(productPrice.replace(/(\d+),(\d+).*/, '$1.$2')),
                    items: [
                        {
                            item_id: productCode,
                            item_name: productName,
                            item_category: productCategoryName,
                            price: parseFloat(productPrice.replace(/(\d+),(\d+).*/, '$1.$2')),
                            quantity: productQuantity
                        }
                    ]
                });
            },
            (response) => {
                this.loading = false;

                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);
            }
        );
    }

    richSnippetFormatPrice(value) {
        return parseFloat(value).toFixed(2).replace(',', '.');
    }

    richSnippetDate() {
        const current = new Date();
        const prior = new Date().setDate(current.getDate() + 30);

        return new Date(prior).toISOString().split('T')[0];
    }

    selectCustomImage() {
        this.$rootScope.$emit('selectCustomImage', {})
    }

    get voucherNameLeftChars() {
        return 50 - (this.voucherForm2.voucherName.$modelValue ? this.voucherForm2.voucherName.$modelValue.length : 0);
    }

    get voucherMessageLeftChars() {
        return 250 - (this.voucherForm2.voucherMessage.$modelValue ? this.voucherForm2.voucherMessage.$modelValue.length : 0);
    }

    get priceFormatted() {
        return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' }).format(
            this.voucher.price,
        );
    }

    get voucherMessageFormatted() {
        return this.voucher.message.replace(/(\r\n|\r|\n)/g, '<br>');
    }

    excludeEmojis() {
        console.log('eem!');
        return /[^\p{L}\s0-9"+\-!@#$%^&*()\[\]={};:'<>,.\/]/g;
    }

    showAvailabilityNotifyButton() {
        return !this.canBuy
            && (!this.productViewModel
                || this.productViewModel.type === 1
                || this.productViewModel.availability_notify_status === 1);
    }

    availabilityNotifyUseRedirect() {
        return this.productViewModel
            && this.productViewModel.type !== 1
            && this.productViewModel.availability_notify_status === 2;
    }

    availabilityNotifyUseModalBeforeRedirect() {
        return this.productViewModel
            && this.productViewModel.type !== 1
            && this.productViewModel.availability_notify_status === 2
            && (this.productViewModel.availability_notify_modal_before_redirect === 1
                || this.productViewModel.availability_notify_modal_before_redirect === '1');
    }

    availabilityNotifyText() {
        return (this.productViewModel && this.productViewModel.availability_notify_text)
            || 'Powiadom o dostępności';
    }

    availabilityNotifyTooltip() {
        return (this.productViewModel && this.productViewModel.availability_notify_tooltip_text)
            || 'Produkt niedostępny';
    }

    availabilityNotifyModalHandler($event) {
        if ($event && typeof $event.preventDefault === 'function') {
            $event.preventDefault();
        }

        const redirectUrl = this.productViewModel && this.productViewModel.availability_notify_redirect_url;

        let redirectTimer = null;

        const modalRef = this.ModalService.add(
            this.productViewModel.availability_notify_modal_header,
            `<div class="text-center">
                <p>${this.productViewModel.availability_notify_modal_content}</p>
            </div>
            <div class="button-container">
                <a
                    class="btn btn-primary"
                    href="${redirectUrl}"
                    target="_blank"
                    rel="noopener noreferrer"
                    ng-click="$ctrl.close()"
                >
                    ${this.productViewModel.availability_notify_modal_button_text}
                </a>
                <button class="btn btn-secondary" type="button" ng-click="$ctrl.close()">Anuluj</button>
            </div>`,
            () => {
                if (redirectTimer) {
                    clearTimeout(redirectTimer);

                    redirectTimer = null;
                }
            },
            true,
            'availability-notify-modal'
        );

        modalRef.open();

        if (!redirectUrl) {
            return;
        }

        redirectTimer = setTimeout(() => {
            window.location.href = redirectUrl;

            modalRef.close();
        }, 5000);
    }

    availabilityNotify() {
        this.availabilityQuestion(this.selectedVariant);
    }

    availabilityAskText() {
        return (this.productViewModel && this.productViewModel.availability_ask_text)
            || 'Zapytaj o dostępność';
    }

    showProcessingTime() {
        return !this.productViewModel
                || this.productViewModel.type === 1
                || this.productViewModel.processing_time_status !== 0;
    }

    processingTimeText() {
        return (this.productViewModel && this.productViewModel.processing_time_text)
            || this.availability.name;
    }

    pricePrefixText() {
        return (this.productViewModel && this.productViewModel.price_prefix_text)
            || '';
    }

    showStationaryShopAvailabilityCheck() {
        return !this.productViewModel
                || this.productViewModel.type === 1
                || this.productViewModel.stationary_shop_availability_check_status === 1;
    }

    showProductCode() {
        return !this.productViewModel
                || this.productViewModel.type === 1
                || this.productViewModel.product_code_status === 1;
    }

    showEan() {
        return !this.productViewModel
                || this.productViewModel.type === 1
                || this.productViewModel.ean_status === 1;
    }
}

let productViewComponent = {
    bindings: {
        product: '<',
        producerLogo: '@',
        images: '<',
        variants: '<',
        complementaryProducts: '<',
        selectedVariant: '<',
        attributesToFilter: '<',
        sizeTable: '<',
        framesDescription: '<',
        cheapestShipmentPrice: '@',
        shipmentModal: '<',
        stationaryStoreAvailabilites: '<',
        informationOnShippingCosts: '@',
        howToChooseFrameSize: '@',
        ratingValue: '<',
        availabilities: '<',
        defaultMetaTitle: '<',
        defaultMetaDescription: '<',
        defaultUrl: '<',
        productViewModel: '<'
    },
    template: productViewHtml,
    controller: ProductViewController
};

export default productViewComponent;
